var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mc-container"},[_c('div',{staticClass:"d-flex flex-column"},[_c('b-button',{attrs:{"variant":"primary mb-2 ml-auto"},on:{"click":_vm.generateOnlendingsByClinic}},[_vm._v(" Gerar repasses médicos ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }